/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { SolutionStatusOnlyDtoModel, SolutionStatusOnlyDtoModelType } from "./SolutionStatusOnlyDtoModel"
import { SolutionStatusOnlyDtoModelSelector } from "./SolutionStatusOnlyDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  pendingSolution: SolutionStatusOnlyDtoModelType;
}

/**
 * ProjectStopsSchedulingFailedDtoBase
 * auto generated base class for the model ProjectStopsSchedulingFailedDtoModel.
 *
 * Scheduling stops failed
 */
export const ProjectStopsSchedulingFailedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('ProjectStopsSchedulingFailedDto')
  .props({
    __typename: types.optional(types.literal("ProjectStopsSchedulingFailedDto"), "ProjectStopsSchedulingFailedDto"),
    projectId: types.union(types.undefined, types.string),
    pendingSolution: types.union(types.undefined, MSTGQLRef(types.late((): any => SolutionStatusOnlyDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class ProjectStopsSchedulingFailedDtoModelSelector extends QueryBuilder {
  get projectId() { return this.__attr(`projectId`) }
  pendingSolution(builder: string | SolutionStatusOnlyDtoModelSelector | ((selector: SolutionStatusOnlyDtoModelSelector) => SolutionStatusOnlyDtoModelSelector) | undefined) { return this.__child(`pendingSolution`, SolutionStatusOnlyDtoModelSelector, builder) }
}
export function selectFromProjectStopsSchedulingFailedDto() {
  return new ProjectStopsSchedulingFailedDtoModelSelector()
}

export const projectStopsSchedulingFailedDtoModelPrimitives = selectFromProjectStopsSchedulingFailedDto().projectId
